import React from 'react';
import './HomePage.css';
import { Link } from 'react-router-dom';

const HomePage = props => {

    const animatePikachu = (event) => {
        event.target.src = require("./Images/pokeball.gif");
    }

    const stopAnimatePikachu = (event) => {
        event.target.src = require("./Images/pokeball-0.png");
    }

    return(
        <div className="HomePage">
            <div className="title">
                <img src={require("./Images/Titre4.png")}/>
            </div>
            <div className="imgpokeball">
                <Link to="/show-elements" className="link"><img src={require("./Images/pokeball-0.png")} onMouseEnter={animatePikachu} onMouseLeave={stopAnimatePikachu}/></Link>
            </div>

        </div>
    );
}

export default HomePage;

